module.exports = {
    dialog: {
        tip: '提 示'
    },
    table: {
        emptyText: '暂无数据'
    },
    pagination: {
        pre: '上一页',
        next: '下一页',
        totalPage: '共{total}页',
        to: '到第',
        page: '页',
        sure: '确定',
        validMsg: {
            inputRule: '请输入正整数'
        }
    },
    dropdown: {
        menu: '下拉菜单',
    },
    errPage: {
        accessError: '啊哦~ 无法访问此网站',
        error404: '啊哦~ 你所访问的页面不存在',
        backHome: '返回首页',
        backPre: '返回上一页',
        tryMethod: '请试试以下方法：',
        checkOpt: ['检查网络', '检查各服务是否运行正常']
    },
    labelSize: {
        screenInfos: [{
            key: '0001',
            value: '1.54"(152*152) 黑白',
            size: '1.54',
            resolution: '152*152',
            rotate: '向左旋转90°',
            color: 'black',
            temperature: ''
        }, {
            key: '0002',
            value: '2.13"(212*104) 黑白',
            size: '2.13',
            resolution: '212*104',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0003',
            value: '2.13"(250*122) 黑白',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0004',
            value: '2.9"(296*128) 黑白',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0005',
            value: '4.2"(400*300) 黑白',
            size: '4.2',
            resolution: '400*300',
            rotate: '向左旋转90°',
            color: 'black',
            temperature: ''
        }, {
            key: '0006',
            value: '1.54"(152*152) 黑白红',
            size: '1.54',
            resolution: '152*152',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0007',
            value: '1.54"(152*152) 黑白黄',
            size: '1.54',
            resolution: '152*152',
            rotate: '向左旋转90°',
            color: 'yellow',
            temperature: ''
        }, {
            key: '0008',
            value: '2.13"(250*122) 黑白红',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0009',
            value: '2.13"(250*122) 黑白黄',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000a',
            value: '2.9"(296*128) 黑白红',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '000b',
            value: '2.9"(296*128) 黑白黄',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000c',
            value: '4.2"(400*300) 黑白红',
            size: '4.2',
            resolution: '400*300',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '000d',
            value: '4.2"(400*300) 黑白黄',
            size: '4.2',
            resolution: '400*300',
            rotate: '向左旋转90°',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000e',
            value: '2.13"(250*122) 低温黑白',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'black',
            temperature: 'low'
        }, {
            key: '000f',
            value: '5.83"(648*480) 黑白红',
            size: '5.83',
            resolution: '648*480',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0010',
            value: '7.5"(880*528) 黑白红',
            size: '7.5',
            resolution: '880*528',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0011',
            value: '2.66"(296*152) 黑白红',
            size: '2.66',
            resolution: '296*152',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0012',
            value: '1.54"(200*200) 黑白红',
            size: '1.54',
            resolution: '200*200',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0013',
            value: '2.13"(250*122) 黑白红',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0014',
            value: '2.9"(296*128) 黑白红',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0015',
            value: '4.2"(400*300) 黑白红',
            size: '4.2',
            resolution: '400*300',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        }, {
            key: '0017',
            value: '11.6"(960*640) 黑白红',
            size: '11.6',
            resolution: '960*640',
            rotate: '向左旋转90°',
            color: 'red',
            temperature: ''
        },{
            key: '8000',
            value: '屏幕损坏',
            size: '',
            resolution: '',
            rotate: '',
            color: '',
            temperature: ''
        }, ]
    },
    allLabelTypeDatas: [{ //树形组件  标签条件查询
            id: '1.54_a',
            label: '1.54 "',
            children: [{
                id: '1.54_b',
                label: '1.54" 黑白'
            }, {
                id: '1.54_r',
                label: '1.54" 黑白红'
            }, {
                id: '1.54_y',
                label: '1.54" 黑白黄'
            }]
        }, {
            id: '2.13_a',
            label: '2.13"',
            children: [{
                id: '2.13_b',
                label: '2.13" 黑白'
            }, {
                id: '2.13_r',
                label: '2.13" 黑白红'
            }, {
                id: '2.13_y',
                label: '2.13" 黑白黄'
            }, {
                id: '2.13_b_low',
                label: '2.13" 低温黑白'
            }]
        },
         {
            id: '2.66_a',
            label: '2.66"',
            disabled: true,
            children: [{
                id: '2.66_b',
                label: '2.66" 黑白',
                disabled: true
            }, {
                id: '2.66_r',
                label: '2.66" 黑白红'
            }, {
                id: '2.66_y',
                label: '2.66" 黑白黄',
                disabled: true
            }]
        }, 
        {
            id: '2.9_a',
            label: '2.9"',
            children: [{
                id: '2.9_b',
                label: '2.9" 黑白'
            }, {
                id: '2.9_r',
                label: '2.9" 黑白红'
            }, {
                id: '2.9_y',
                label: '2.9" 黑白黄'
            }]
        }, {
            id: '4.2_a',
            label: '4.2"',
            children: [{
                id: '4.2_b',
                label: '4.2" 黑白'
            }, {
                id: '4.2_r',
                label: '4.2" 黑白红'
            }, {
                id: '4.2_y',
                label: '4.2" 黑白黄'
            }]
        }, {
            id: '5.83_a',
            label: '5.83"',
            disabled: true,
            children: [{
                id: '5.83_b',
                label: '5.83" 黑白',
                disabled: true
            }, {
                id: '5.83_r',
                label: '5.83" 黑白红',
                // disabled: true
            }, {
                id: '5.83_y',
                label: '5.83" 黑白黄',
                disabled: true
            }]
        }, {
            id: '7.5_a',
            label: '7.5"',
            disabled: true,
            children: [{
                id: '7.5_b',
                label: '7.5" 黑白',
                disabled: true
            }, {
                id: '7.5_r',
                label: '7.5" 黑白红',
                // disabled: true
            }, {
                id: '7.5_y',
                label: '7.5" 黑白黄',
                disabled: true
            }]
        }, {
            id: '11.6_a',
            label: '11.6"',
            disabled: true,
            children: [{
                id: '11.6_b',
                label: '11.6" 黑白',
                disabled: true
            }, {
                id: '11.6_r',
                label: '11.6" 黑白红',
                // disabled: true
            }, {
                id: '11.6_y',
                label: '11.6" 黑白黄',
                disabled: true
            }]
        }
    ],
    // excelComment: '条形码长度固定为13位数字',
    excelComment: {
        id: 'ID由字母或数字组成',
        qrcode: '二维码系统将根据ID自动生成，不用填写；如果填写，仍然采用系统自动生成的二维码'
    },
    labelPreview: {
        loadErr: '图片加载失败',
        chooseImg: '请选择要绘制的图片',
        brErr: '条形码请输入数字或字母，否则无法显示',
        brErr1: '条形码请输入13位数字，否则无法显示'
    },
    viewPermis: {
        demo: '您没有权限查看该门店的模板相关页面',
        editDemo: '您没有权限编辑该门店的模板',
        sysDemo: '您没有权限查看系统模板相关页面',
        system: '您没有权限查看系统页面',
        errcode: '您没有权限查看错误码页面',
        shopSetting: '您没有权限查看该门店的设置页面',
        hasStore: '您不是该门店成员，无法查看该门店数据，请联系管理员为您分配该门店',
        storeClose: '您查看的门店已关闭'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/common.js